<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Serviceintervaller</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <div class="period flex-wrap margin--bottom-m">
    <div>
      <span class="period__month period__month--solid opkraevning">&nbsp;</span>
      <span>Opkrævning</span>
    </div>
    <div>
      <span class="period__month period__month--solid eftersyn">&nbsp;</span>
      <span>Eftersyn</span>
    </div>
    <div>
      <span class="period__month naesteEftersynDate">&nbsp;</span>
      <span>Kommende eftersyn</span>
    </div>
    <div>
      <span class="period__month opkraevningDate">&nbsp;</span>
      <span>Kommende opkrævning</span>
    </div>
    <div>
      <span class="period__offset startDate">&nbsp;</span>
      <span>Start</span>
    </div>
    <div>
      <span class="period__offset endDate">&nbsp;</span>
      <span>Opsagt</span>
    </div>
  </div>

  @for (serviceinterval of serviceintervaller; track serviceinterval) {
    <mat-expansion-panel
      class="margin--bottom-m"
      [expanded]="isCurrentServiceinterval(serviceinterval)"
      >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div>
            {{ serviceinterval.startDate | date : 'dd.MM.yyyy' }} - {{ serviceinterval.endDate | date : 'dd.MM.yyyy' }}
            <br />
            <strong>
              {{ serviceinterval.serviceAbonnement?.description }}
              @if (serviceinterval.tilvalg?.length > 0) {
                <span>- {{ getTilvalg(serviceinterval) }}</span>
              }
            </strong>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="period">
        @if (getddOffsetPx(serviceinterval)) {
          <div class="period__dd period__dd--no-heading" [style.left]="getddOffsetPx(serviceinterval)">
            <span>d.d.</span>
          </div>
        }
        <app-serviceinterval-bar-graph [months]="getMonth(serviceinterval)"></app-serviceinterval-bar-graph>
      </div>
      @for (eftersyn of GetEftersynOutsideInterval(serviceinterval); track eftersyn) {
        <div>
          <span>OBS eftersyn for dette serviceinterval vises ikke, da deadline er {{ eftersyn | date : 'dd.MM.yyyy' }}</span>
        </div>
      }
    </mat-expansion-panel>
  }
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-dialog-close mat-raised-button color="primary">OK</button>
</div>
